import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      UNSUBSCRIBE: "Abonnement pauset",
      FINISHED: "Suksess!",
      YOUR_DELIVERIES_ARE_STOPPED: "Dine leveranser er satt på pause!",
      WOULD_NOT_RECEIVE_DELIVERIES_UNTIL_REACTIVATE_ACC:
        "Du vil ikke motta noen leveranser før du gjenopptar kontoen din.",
      WE_HOPE_TO_SEE_YOU_BACK: "Velkommen tilbake snart!",
      TO_MY_ACCOUNT: "Til min konto",
      CHANGED_YOUR_MIND: "Angrer du?",
      YOU_CAN_REACTIVATE_ANYTIME:
        "Du kan raskt starte dine leveranser igjen, når du vil og uten bindingstid!",
      REACTIVATE: "Gjenoppta leveranser",
    },
    se: {
      UNSUBSCRIBE: "Prenumeration avslutad",
      FINISHED: "Klart!",
      YOUR_DELIVERIES_ARE_STOPPED: "Dina prenumeration är avslutad!",
      WOULD_NOT_RECEIVE_DELIVERIES_UNTIL_REACTIVATE_ACC:
        "Du kommer inte att ta emot några leveranser förrän du återupptar ditt konto.",
      WE_HOPE_TO_SEE_YOU_BACK: " Välkommen tillbaka snart!",
      TO_MY_ACCOUNT: "Till mitt konto",
      CHANGED_YOUR_MIND: "Ångrar du dig?",
      YOU_CAN_REACTIVATE_ANYTIME:
        "Du kan snabbt starta dina leveranser igen, när du vill och utan bindningstid!",
      REACTIVATE: "Återuppta leveranser",
    },
    dk: {
      UNSUBSCRIBE: "Abonnement er sat på pause",
      FINISHED: "Færdig!",
      YOUR_DELIVERIES_ARE_STOPPED: "Dine leveringer er stoppet!",
      WOULD_NOT_RECEIVE_DELIVERIES_UNTIL_REACTIVATE_ACC:
        "Du vil ikke modtage nogen leveringer, før du genaktiverer din konto.",
      WE_HOPE_TO_SEE_YOU_BACK: "Vi håber at se dig tilbage igen!!",
      TO_MY_ACCOUNT: "Til min konto",
      CHANGED_YOUR_MIND: "Fortryder du?",
      YOU_CAN_REACTIVATE_ANYTIME:
        "Du kan genaktivere når som helst og er velkommen tilbage.",
      REACTIVATE: "Genaktivér",
    },
  } as const
)[language];
